import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import "./ChatMessageText.scss";
import "../VipMessage/VipMessage.scss";
import "../../chatMentions/chatMentions.scss";

const URL_PATTERN = /(\bhttps?:\/\/[^\s<]+|\bwww\.[^\s<]+)/gi;
const MENTION_PATTERN = /@([a-zA-Z0-9_.]{2,32})/g;
const TOKEN_PATTERN = new RegExp(
  `${MENTION_PATTERN.source}|${URL_PATTERN.source}`,
  "gi"
);

const normalizeLinkHref = (url) =>
  url.startsWith("www.") ? `https://${url}` : url;

const parseMessageParts = (text) => {
  if (!text) return [{ type: "text", value: "" }];

  const parts = [];
  let lastIndex = 0;
  const regex = new RegExp(TOKEN_PATTERN.source, TOKEN_PATTERN.flags);
  let match = regex.exec(text);

  while (match) {
    if (match.index > lastIndex) {
      parts.push({ type: "text", value: text.slice(lastIndex, match.index) });
    }
    const token = match[0];
    if (token.startsWith("@")) {
      parts.push({ type: "mention", value: token, userName: match[1] });
    } else {
      parts.push({ type: "link", value: token });
    }
    lastIndex = regex.lastIndex;
    match = regex.exec(text);
  }

  if (lastIndex < text.length) {
    parts.push({ type: "text", value: text.slice(lastIndex) });
  }

  return parts.length ? parts : [{ type: "text", value: text }];
};

const renderLine = (line, lineKey, currentUserName) =>
  parseMessageParts(line).map((part, index) => {
    if (part.type === "link") {
      return (
        <a
          key={`${lineKey}-link-${index}`}
          href={normalizeLinkHref(part.value)}
          target="_blank"
          rel="noopener noreferrer"
          className="chat-message-link"
          onClick={(e) => e.stopPropagation()}
        >
          {part.value}
        </a>
      );
    }
    if (part.type === "mention") {
      const isSelf =
        currentUserName &&
        String(part.userName).toLowerCase() ===
          String(currentUserName).toLowerCase();
      return (
        <span
          key={`${lineKey}-mention-${index}`}
          className={`chat-mention${isSelf ? " is-self" : ""}`}
        >
          {part.value}
        </span>
      );
    }
    return (
      <span key={`${lineKey}-text-${index}`} className="chat-message-text-part">
        {part.value}
      </span>
    );
  });

const ChatMessageText = ({
  text,
  paragraphClassName = "chat-message-line",
  currentUserName: currentUserNameProp,
}) => {
  const userData = useSelector((state) => state.user.userData);
  const currentUserName = currentUserNameProp || userData?.userName;

  if (!text) return null;

  return text.split("\n").map((line, lineIndex) => (
    <p key={`line-${lineIndex}`} className={paragraphClassName}>
      {renderLine(line, lineIndex, currentUserName)}
    </p>
  ));
};

ChatMessageText.propTypes = {
  text: PropTypes.string,
  paragraphClassName: PropTypes.string,
  currentUserName: PropTypes.string,
};

export default ChatMessageText;
